import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ChangeImageOpacityAction extends AbstractProvidedClass {
    isImageAction = true;

    constructor(provider, slider) {
        super(provider);

        this.slider = slider;
        this.oldOpacity = this.image.opacity;
    }

    update() {
        this.image.opacity = this.slider.value();
    }

    finish() {
        this.newOpacity = this.slider.value();
        this.image.opacity = this.newOpacity;
        this.actions.finish();
    }

    undo() {
        this.image.opacity = this.oldOpacity;
        this.slider.value(this.oldOpacity);
    }

    redo() {
        this.image.opacity = this.newOpacity;
        this.slider.value(this.newOpacity);
    }
}
